import React from "react";
import Porfolio from "./components/Portfolio";

const App = () => <Porfolio />;

export default App;
